import * as baseValidations from "../validators/baseValidator";
import i18next from "i18next";

export const validateEmail = (email) => {
  const emailRegex =
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_%+-]+(\.[A-Za-z0-9_%+-]+)*)@([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;

  if (!email) {
    return `${i18next.t("account.emailRequired")}`;
  } else if (!emailRegex.test(email) || email.includes("..")) {
    return `${i18next.t("account.invalidEmail")}`;
  } else {
    return "";
  }
};
// export const validatePassword = (password) => {
//   if (!password) {
//     return "Password must be at least 8 characters long and include at least 1 capital letter, 1 number, and 1 special character (!@#$%^&*)";
//   }

//   const regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;
//   if (!regex.test(password)) {
//     return "Password must be at least 8 characters long and include at least 1 capital letter, 1 number, and 1 special character (!@#$%^&*)";
//   }

//   return "";
// };

export const validatePassword = (password) => {
  if (!baseValidations.IsPresent(password)) {
    return `${i18next.t("account.passwordRequired")}`;
  }
  if (!baseValidations.minLength(password, 6)) {
    return `${i18next.t("account.passwordTooShort")}`;
  }
  return "";
};
export const validateCardHolderName = (name, t) => {
  if (!name) {
    return `${i18next.t("checkout.cardHolderNameRequired")}`;
  } else if (name.trim().length < 2) {
    return `${i18next.t("checkout.cardHolderNameMinLength")}`;
  } else if (!/^[a-zA-Z ]+$/.test(name)) {
    return `${i18next.t("checkout.cardHolderNameInvalid")}`;
  } else {
    return "";
  }
};

export const validateState = (state, stateName, t) => {
  if (!state) {
    return `${formatLabel(stateName)} ${i18next.t("checkout.isRequired")}`;
  } else {
    return "";
  }
};

export const validateZip = (zip, t) => {
  if (!zip) {
    return `${i18next.t("checkout.zip_code_Required")}`;
  } else {
    return "";
  }
};

export const formatLabel = (text) => {
  if (!text) {
    return text; // Return the original text if it's falsy
  }

  return text
    .toLowerCase() // Convert to lowercase first
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};

export const validatePostalCode = (postalCode, postalCodeName, t) => {
  if (!postalCode) {
    return `${formatLabel(postalCodeName)} ${i18next.t("checkout.isRequired")}`;
  } else {
    return "";
  }
};

export const validateCity = (city, cityName, t) => {
  if (!city) {
    return `${formatLabel(cityName)} ${i18next.t("checkout.isRequired")}`;
  } else {
    return "";
  }
};

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0-11, so add 1

export const validateExpMonth = (month, year, t) => {
  if (!month) {
    return `${i18next.t("checkout.expirationMonthRequired")}`;
  }
  if (
    Number(year) === Number(currentYear) &&
    Number(month) < Number(currentMonth)
  ) {
    return `${i18next.t("checkout.expirationMonthFuture")}`;
  } else if (Number(month) < 1 || Number(month) > 12) {
    return `${i18next.t("checkout.invalidMonth")}`;
  } else {
    return "";
  }
};

export const validateExpYear = (year, month, t) => {
  if (!year) {
    // year = currentYear;
    return `${i18next.t("checkout.expirationYearRequired")}`;
  }
  if (year < currentYear) {
    return `${i18next.t("checkout.expirationYearFuture")}`;
  } else if (year === currentYear && month < currentMonth) {
    return `${i18next.t("checkout.invalidYearMonthCombination")}`;
  } else {
    return "";
  }
};

export const validateCardNumber = (value, t) => {
  if (value === "") {
    return `${i18next.t("checkout.cardNumberRequired")}`;
  }

  const cardNumberRegex = /^[0-9]{16}$/;
  return cardNumberRegex.test(value)
    ? ""
    : `${i18next.t("checkout.cardNumberFormat")}`;
};

export const validateCVV = (value, t) => {
  if (value === "") {
    return `${i18next.t("checkout.cvvRequired")}`;
  }

  const cvvRegex = /^[0-9]{3,4}$/;
  return cvvRegex.test(value) ? "" : `${i18next.t("checkout.invalid_cvv")}`;
};

export const allowOnlyAlphabetsSpaceFirstLetterCapital = (e) => {
  e.target.value = e.target.value.replace(/[^a-z\s]/gi, "");
  e.target.value = e.target.value.replace(/^(.)|\s+(.)/g, (c) =>
    c.toUpperCase(),
  );
};

export const allowOnlyAlphabetsSpaceHyphenFirstLetterCapital = (e) => {
  e.target.value = e.target.value.replace(/[^a-z\s-]/gi, "");
  e.target.value = e.target.value.replace(/^(.)|\s+(.)/g, (c) =>
    c.toUpperCase(),
  );
  e.target.value = e.target.value.replace(/-+/g, "-"); // Prevent multiple consecutive hyphens
};

export const allowOnlyNumbers = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, "");
};

export const allowOnlyAlphabetsAndNumbersAndSpaces = (e) => {
  e.target.value = e.target.value.replace(/[^a-z0-9\s]/gi, "");
};

export const formatPostalCode = (e) => {
  let input = e.currentTarget;
  // Convert to uppercase, allow alphanumeric & spaces, limit to 9 characters
  input.value = input.value
    .toUpperCase() // Convert to uppercase
    .replace(/[^A-Z0-9\s]/g, "") // Allow only alphanumeric & spaces
    .replace(/^\s+/g, "") // Remove leading spaces
    .slice(0, 9); // Limit to 9 characters
};

export const formatCityState = (e) => {
  let input = e.currentTarget;
  // Allow only letters, spaces, and dashes, remove leading spaces, limit to 50 chars
  input.value = input.value
    .replace(/[^A-Za-z\s-]/g, "") // Only letters, spaces, and dashes
    .replace(/^\s+/g, "") // Remove leading spaces
    .slice(0, 50); // Limit to 50 characters
};

// Validation utility functions
export const isValidGuid = (value) => {
  if (!value) return false;
  let regExp =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return regExp.test(value);
};

export const isValidString = (value) => {
  if (!value || typeof value !== "string") return false;
  // Only allow letters, spaces, apostrophes, and hyphens
  const stringRegex = /^[a-zA-Z\s'-]+$/;
  return stringRegex.test(value.trim()) && value.trim().length > 0;
};
